import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonTranslationsDE from './de/common.json';
import commonTranslationsEN from './en/common.json';

const resources = {
  en: {
    common: commonTranslationsEN,
  },
  de: {
    common: commonTranslationsDE,
  },
};

i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    keySeparator: '.',
    resources,
    lng: 'en',
    fallbackLng: 'en',
  });

export default i18n;
